import { Configuration, DefaultApi } from "../gen/assetgeneration";
import { AssetGenerationBundle, AssetGenerationProgress } from "../model";
import {} from "../gen/assetgeneration";
import { QualityLevel } from "./IAssetGenerationController";
import { getAuthInfo } from "../utility/AccountUtility";
export class DefaultAssetGenerationController {
    backendUrl;
    constructor(backendUrl) {
        this.backendUrl = backendUrl;
    }
    getBaseUrl() {
        return this.backendUrl;
    }
    netProgressToProgress(result) {
        let individualResult = new AssetGenerationProgress();
        individualResult.jobId = result.jobId;
        individualResult.progress = result.progress ? result.progress : 0;
        individualResult.total = result.total;
        individualResult.assetUrl = result.assetUrl;
        individualResult.error = result.error;
        return individualResult;
    }
    getApi() {
        let authInfo = getAuthInfo();
        let api = new DefaultApi(new Configuration({
            basePath: this.backendUrl,
            accessToken: authInfo.getToken(),
        }));
        return api;
    }
    async generateMultipleImagesFromPrompt(prompt, notprompt, dimensions, count, quality, transparency = false) {
        let api = this.getApi();
        let groupedResult = new AssetGenerationBundle();
        let desiredDimension = "1024x1024";
        let x = dimensions[0];
        let y = dimensions[1];
        desiredDimension = `${x}x${y}`;
        for (let i = 0; i < count; i++) {
            let result = await api.generateImgPost({
                imgPromptRequest: {
                    prompt: prompt,
                    antiprompt: notprompt,
                    dimensions: desiredDimension,
                    transparency: transparency
                }
            });
            let individualResult = this.netProgressToProgress(result);
            groupedResult.subJobs.push(individualResult);
        }
        return groupedResult;
    }
    async getStatus(progressId) {
        let api = this.getApi();
        let result = await api.statusAssetIdGet({
            assetId: progressId
        });
        return this.netProgressToProgress(result);
    }
    async getGroupStatus(progressBundle) {
        let result = progressBundle;
        let newIndividuals = [];
        for (let individualProgress of result.subJobs) {
            let individualResult = await this.getStatus(individualProgress.jobId);
            newIndividuals.push(this.netProgressToProgress(individualResult));
        }
        result.subJobs = newIndividuals;
        return result;
    }
}
